import { render, staticRenderFns } from "./parallel_draft_comment_row.vue?vue&type=template&id=446b0ed4&"
import script from "./parallel_draft_comment_row.vue?vue&type=script&lang=js&"
export * from "./parallel_draft_comment_row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "parallel_draft_comment_row.vue"
export default component.exports